module.exports = __webpack_public_path__ + "static/media/ciel-plage2.b3d1bd36.png";